import React from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
import JobProtal from "../Components/Dashboard/JobProtal";
const AuthJobprotal = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <JobProtal /> : <SessionTimeoutRedirect />
}
export default AuthJobprotal;


